import AuthBusiness from "@/business/AuthBusiness.js";
import FrontBusiness from "@/business/FrontBusiness";
import LivroMatriculaBusiness from "@/business/livros/LivroMatriculaBusiness.js";
import CertidaoBusiness from "@/business/protocolo/CertidaoBusiness.js";
import RegrasEstaduaisRSBusiness from "@/business/RegrasEstaduaisRSBusiness.js";
import SeloBusiness from "@/business/SeloBusiness.js";
import VueBusiness from "@/business/VueBusiness.js";
import moment from 'moment';

export default {

  async gerarDicionario(certidao, protocolo, simplificado = false){

    const dicionario = {
      hoje : moment(),
      usuario :{},
      usuarioLogado : { }
    };

    if(!simplificado){
      await AuthBusiness.getLoggedUser().then(logged => dicionario.usuarioLogado = { ...logged, senha : undefined });
    }

    if(certidao.usuarioSelo?.nome){
      dicionario.usuario.selagem = certidao.usuarioSelo.nome;
    }

    /**
     * CONFIGURACOES DO certidao
     */
    dicionario.certidao = {
      id : certidao.id,
      codigo : certidao.pedido,
      pedido : certidao.pedido,
      selado : certidao.selado,
      isento : certidao.isento,
      tipo : FrontBusiness.getLabel(certidao?.tipoServico?.opcoes?.tipoCertidao, CertidaoBusiness.tiposCertidao()),
      titulo : certidao?.tipoServico?.nome,
      valores : {},
      protocolo : protocolo.codigo,
      cadastro : protocolo.cadastro
    };

    if (certidao.ressarcimento) {
      dicionario.certidao.ressarcimento = {
        codigoIsencao: certidao.ressarcimento?.motivoIsencao?.split('_')?.[1] || null,
        codigoIsencaoProcessamentoEletronico: certidao.ressarcimento?.motivoIsencaoProcessamentoEletronico?.split('_')?.[1] || null,
        codigoIsencaoBusca: certidao.ressarcimento?.motivoIsencaoBusca?.split('_')?.[1] || null,
        codigoIsencaoDigitalizacao: certidao.ressarcimento?.motivoIsencaoDigitalizacao?.split('_')?.[1] || null,
      };
    }

    // INDICES
    if (certidao.indices != null) {
      dicionario.checklist = {};

      Object.keys(certidao.indices).forEach(i => {
        dicionario.checklist[i] = certidao.indices[i];
        dicionario.checklist[i.toUpperCase()] = certidao.indices[i];
        dicionario.checklist[i.toLowerCase()] = certidao.indices[i];
      });

    }

    dicionario.ficha = { type : '', id : null, paginas : [], livro : null };

    if(certidao.indicadorReal?.id){
      dicionario.imovel = await LivroMatriculaBusiness.gerarDicionarioImovel(certidao.indicadorReal, simplificado);
      dicionario.ficha = {...dicionario.ficha, ...certidao.indicadorReal};
    }

    if(certidao.registroAuxiliar?.id){
      dicionario.registroAuxiliar = await LivroMatriculaBusiness.gerarDicionarioRegistroAuxiliar(certidao.registroAuxiliar, simplificado);
      dicionario.ficha = {...dicionario.ficha, ...certidao.registroAuxiliar};
    }

    if(!dicionario.ficha?.id){
      dicionario.ficha = null;
    }

    // GERA AS TAXAS DO PROTOCOLO:
    if(!simplificado){
      const obj = FrontBusiness.somarTaxas(certidao.custas);
      dicionario.certidao = {...dicionario.certidao, ...obj};

      // VRC apenas para o Paraná
      if (VueBusiness.getVueRoot().isEstadoPR && certidao.custas) {
        const vrc = Object.values(certidao.custas).reduce((sum, c) => sum + ((c.vrc || 0) * (c.quantidade || 1)), 0);
        dicionario.certidao.vrc = vrc;
      }

      const posteriorZerado = {resumo: {emolumentos: 0, iss: 0, custoSelo: 0, total: 0}};
      const valoresPosterior = VueBusiness.getVueRoot().isEstadoRS ? await RegrasEstaduaisRSBusiness.getValoresPosteriorCertidao(certidao.id).catch(e => posteriorZerado) : posteriorZerado;

      dicionario.certidao.emolumentosPosterior = valoresPosterior?.resumo?.emolumentos || 0;
      dicionario.certidao.issPosterior = valoresPosterior?.resumo?.iss || 0;
      dicionario.certidao.custoseloPosterior = valoresPosterior?.resumo?.custoSelo || 0;
      dicionario.certidao.totalPosterior = valoresPosterior?.resumo?.total || 0;
      dicionario.certidao.processamentoEletronicoPosterior = valoresPosterior?.processamentoEletronico || null;
      dicionario.certidao.buscasPosterior = valoresPosterior?.buscas || null;
      dicionario.certidao.digitalizacaoPosterior = valoresPosterior?.digitalizacao || null;
      dicionario.certidao.principalPosterior = valoresPosterior?.principal || null;

      dicionario.seloPrincipal = await SeloBusiness.getSeloCertidao(certidao.id).catch(e => null);
      dicionario.selo = dicionario.seloPrincipal?.codigo;
    }

    return dicionario;

  }

}
